import React, { Fragment, useEffect } from 'react';
import {
  ListGroup,
  Block,
  BlockTitle,
  Badge,
  Icon,
  Button,
  f7
} from 'framework7-react';
import Radio from './../customF7/radio/radio';
import ListItem from '../customF7/list-item/list-item';
import ListInput from '../customF7/list-input/list-input';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import de from 'date-fns/locale/de';
import en from 'date-fns/locale/en-GB';
import fr from 'date-fns/locale/fr';
import II18 from '../translate/II18';
import PropTypes from 'prop-types';
import {
  displayDate,
  checkDateAndGetISODate,
  calcWidgetMonospace,
  defineLayoutSize,
  formOptionHtmlId,
  formOptionInputHtmlId,
  prepareDateToFormData,
  getAbsolutePlaceTooltipInfo
} from './utils';
import Select from 'react-select';
import { Portal } from 'react-overlays';
import { md5Password } from '../home/utils';
import dial_data from '../helpers/country_dial_info';
import {
  isFormItemValidationHasErrors,
  validateFormItem
} from '../helpers/formUtils';
import { createFixedF7Tooltip } from '../helpers/tooltipUtils';
import InfoTooltipIcon from '../common/InfoTooltipIcon';

registerLocale('de-DE', de);
registerLocale('en-US', en);
registerLocale('fr-FR', fr);

export const FORMELEMENTS_PARAGRAPH = 'Paragraph';
export const FORMELEMENTS_LABEL = 'Label';
export const FORMELEMENTS_LINEBREAK = 'LineBreak';
export const FORMELEMENTS_TEXTINPUT = 'TextInput';
export const FORMELEMENTS_NUMBERINPUT = 'NumberInput';
export const FORMELEMENTS_TEXTAREA = 'TextArea';
export const FORMELEMENTS_DROPDOWN = 'Dropdown';
export const FORMELEMENTS_SIGNATURE = 'Signature';
export const FORMELEMENTS_CHECKBOXES = 'Checkboxes';
export const FORMELEMENTS_DATEPICKER = 'DatePicker';
export const FORMELEMENTS_TIMEPICKER = 'TimePicker';
export const FORMELEMENTS_RADIOBUTTONS = 'RadioButtons';
export const FORMELEMENTS_HYPERLINK = 'HyperLink';
export const FORMELEMENTS_RECTANGLE = 'Rectangle';
export const FORMELEMENTS_MOBILE_SPLIT_NUMBER = 'MobileSplitNumber';
export const FORMELEMENTS_IMAGE = 'Image';
export const FORMELEMENTS_ACCEPT_BUTTON = 'AcceptButton';
export const ACCEPT_BUTTON_ACCEPTED = 'true';

const FormElements = {};
/*const myxss = new xss.FilterXSS({
  whiteList: {
    u: [],
    br: [],
    b: [],
    i: [],
    ol: ['style'],
    ul: ['style'],
    li: [],
    p: ['style'],
    sub: [],
    sup: [],
    div: ['style'],
    em: [],
    strong: [],
    span: ['style']
  }
});*/

function getInputLabel(props) {
  return (
    props.label + (props.optionalInfo ? ' (' + props.optionalInfo + ')' : '')
  );
}

function getInputLabelElement(props) {
  if (props.label) {
    if (props.quickForm) {
      return (
        <span slot="inner-start">
          <span className="inputLabel">
            <label htmlFor={props.inputId}>{props.label}</label>
            <span>
              {props.optionalInfo && <Badge>{props.optionalInfo}</Badge>}
            </span>
          </span>
        </span>
      );
    } else {
      return (
        <label
          htmlFor={props.inputId}
          slot="inner-start"
          className={'screenreader'}
        >
          {props.label}
        </label>
      );
    }
  }
  return null;
}

getInputLabelElement.propTypes = {
  quickForm: PropTypes.bool,
  label: PropTypes.string,
  optionalInfo: PropTypes.string
};

function getFooter(props) {
  return (
    props.errorMessage && (
      <label
        className={props.errorMessage ? 'customFormInputError' : ''}
        slot={'footer'}
      >
        {props.errorMessage ? props.errorMessage : props.optionalInfo}
      </label>
    )
  );
}

function getAbsolutePlaceModeClearButton(props) {
  return (
    props.value &&
    !props.readonly && (
      <span
        onClick={() => props.onChange('')}
        className={'pdfFormClearButton input-clear-button'}
        slot={'root-end'}
      ></span>
    )
  );
}

getFooter.propTypes = {
  errorMessage: PropTypes.string,
  optionalInfo: PropTypes.string
};

function Rectangle(props) {
  return (
    <li
      key={props.key}
      style={props.style}
      className={props.className + ' staticElement Rectangle'}
    >
      <div
        style={{
          backgroundColor: props.data.color,
          width: '100%',
          height: '100%'
        }}
      />
    </li>
  );
}

Rectangle.propTypes = {
  className: PropTypes.string,
  key: PropTypes.string,
  style: PropTypes.string,
  data: PropTypes.object
};

function Image(props) {
  return (
    <Block key={props.key} className={props.className + ' staticElement Image'}>
      <img
        alt="Form"
        src={props.data.imageSignedUrl}
        style={{ width: '100%' }}
      />
    </Block>
  );
}

Image.propTypes = {
  className: PropTypes.string,
  key: PropTypes.string,
  style: PropTypes.string,
  data: PropTypes.object
};

function fixTextStyle(textStyle) {
  const result = textStyle || {};
  result.color = result.color || '#000';
  result.fontStyle = result.fontStyle || 'normal';
  result.fontWeight = result.fontWeight || 'normal';
  result.fontSize = result.fontSize || '12';
  return result;
}

function Paragraph(props) {
  const textStyle = fixTextStyle(props.textStyle);
  return (
    <div
      id={props.id}
      key={props.key}
      className={props.className + ' staticElement Paragraph'}
      style={{
        ...props.style,
        backgroundColor: '#fff'
      }}
    >
      <p
        style={
          props.quickForm
            ? {
                fontWeight: textStyle.fontWeight
              }
            : {
                color: textStyle.color,
                fontStyle: textStyle.fontStyle,
                fontSize: textStyle.fontSize * props.scale.scaleY + 'px',
                fontWeight: textStyle.fontWeight,
                padding: 0,
                whiteSpace: 'nowrap',
                lineHeight: 'initial' //(textStyle.fontSize * props.scale.scaleY + 2) + 'px',
                /*transform: `scale(${props.scale.scaleX}, ${props.scale.scaleY})`,
                transformOrigin: 'left top'*/
              }
        }
      >
        {props.data.label.split('\n').map((item, key) => {
          return (
            <Fragment key={key}>
              {item}
              <br />
            </Fragment>
          );
        })}
      </p>
    </div>
  );
}

Paragraph.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  key: PropTypes.string,
  style: PropTypes.string,
  textStyle: PropTypes.string,
  data: PropTypes.object,
  scale: PropTypes.object,
  quickForm: PropTypes.bool
};

function Label(props) {
  if (props.style) {
    props.style.lineHeight = props.style.height + 'px';
  }
  return (
    <BlockTitle {...props}>
      {props.label}
      {props.tooltip ? (
        <InfoTooltipIcon
          id={`${props.inputId || props.id || 'label'}_info`}
          text={props.tooltip}
        />
      ) : null}
    </BlockTitle>
  );
}

Label.propTypes = {
  label: PropTypes.string,
  style: PropTypes.object,
  tooltip: PropTypes.string,
  inputId: PropTypes.string,
  id: PropTypes.string
};

function LineBreak(props) {
  return <ListItem className={'form-divider'} key={props.key} divider />;
}

LineBreak.propTypes = {
  key: PropTypes.string
};

function HyperLink(props) {
  return (
    <ListItem
      {...props}
      className={props.className + ' staticElement HyperLink'}
      link={
        props.data.href && props.data.href.indexOf('http') !== -1
          ? props.data.href
          : 'https://' + props.data.href
      }
      title={props.data.label || (props.quickForm ? props.data.href : '')}
      target="_blank"
      external
    />
  );
}

HyperLink.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
  quickForm: PropTypes.bool
};

function AcceptButton(props) {
  // FormElements are invoked as plain functions from FormInput; hooks need a real component.
  return <AcceptButtonWithTooltip {...props} />;
}

function AcceptButtonWithTooltip(props) {
  const style = props.style;

  useEffect(() => {
    if (!props.tooltip || !props.inputId || !f7) {
      return undefined;
    }

    const targetEl = document.getElementById(props.inputId);
    if (!targetEl) {
      return undefined;
    }

    const instance = createFixedF7Tooltip(f7, {
      targetEl,
      text: props.tooltip,
      cssClass: props.tooltipError ? 'err' : undefined
    });

    return () => {
      if (instance && instance.destroy) {
        instance.destroy();
      }
    };
  }, [props.tooltip, props.tooltipError, props.inputId, props.value]);

  return props.value === ACCEPT_BUTTON_ACCEPTED ? (
    <label
      style={{
        ...style,
        padding: '0 15px',
        width: style.width - 30
      }}
      id={props.inputId}
      className={props.className + ' acceptedButton'}
    >
      <Icon icon={'fas fa-check'} /> {props.title}
    </label>
  ) : (
    <Button
      id={props.inputId}
      onClick={props.onClick}
      className={props.className + ' acceptButton'}
      style={{
        ...style,
        ...(props.quickForm && { marginLeft: 10, marginRight: 10 })
      }}
      raised
      fill
    >
      {props.title}
    </Button>
  );
}

AcceptButtonWithTooltip.propTypes = {
  inputId: PropTypes.string,
  title: PropTypes.string,
  style: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.bool,
  quickForm: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipError: PropTypes.bool,
  onClick: PropTypes.func
};

AcceptButton.propTypes = AcceptButtonWithTooltip.propTypes;

function NumberInput(props) {
  return TextInput({
    ...props,
    step: 'any'
  });
}

function TimeInput(props) {
  return TextInput({
    ...props,
    onChange: e => props.onChange(e.target.value.slice(0, 5)),
    type: props.readonly ? 'text' : 'time',
    min: '00:00',
    max: '23:59',
    step: 60,
    pattern: '[0-9]{2}:[0-9]{2}'
  });
}
TimeInput.propTypes = {
  onChange: PropTypes.func
};

const normalizeCode = code => {
  let result = code;
  for (let i = 0; i < 8 - code.length; i++) result += '&nbsp;';
  return result;
};

function MobileSplitNumber(props) {
  const currentValue = props['value'] || { code: '+49', number: '' };
  if (props.activeMode) {
    props['defaultValue'] = currentValue.number;
    delete props['value'];
  } else {
    props['value'] = currentValue.number;
  }

  delete props['placeholder'];

  return (
    <ListInput
      {...props}
      className={
        props.className + ' mobilePhoneNumber ' + md5Password(currentValue)
      }
      type={'text'}
      label={''}
      clearButton={!props.readonly}
      onChange={e =>
        props.onChange({
          number: e.target.value,
          code: currentValue.code
        })
      }
      onInputClear={() =>
        props.onChange({
          number: '',
          code: currentValue.code
        })
      }
    >
      <select
        disabled={props.readonly}
        onChange={e => {
          props.onChange({
            number: currentValue.number,
            code: e.target.value
          });
        }}
        value={currentValue.code}
        slot={'content-start'}
      >
        {dial_data.map((data, index) => (
          <option
            key={data.dial_code + index}
            value={data.dial_code}
            dangerouslySetInnerHTML={{
              __html: normalizeCode(data.dial_code) + data.name
            }}
          />
        ))}
      </select>
      {getInputLabelElement(props)}
    </ListInput>
  );
}

MobileSplitNumber.propTypes = {
  activeMode: PropTypes.bool,
  className: PropTypes.string,
  readonly: PropTypes.bool,
  value: PropTypes.any,
  placeholder: PropTypes.any,
  onChange: PropTypes.func
};

function TextInput(props) {
  const showMonoSpace =
    props.monoSpace && props.maxlength && props.desktop && !props.quickForm;
  let inputStyle = {};
  if (showMonoSpace) {
    inputStyle = calcWidgetMonospace(
      props.data.width,
      props.data.height,
      props.scale.scaleY,
      props.maxlength
    );
    inputStyle.background = 'transparent';
  }

  const defaultValue = props['value'];
  if (props.activeMode) {
    props['defaultValue'] = props['value'];
    delete props['value'];
  }

  if (!props.placeholder) {
    delete props['placeholder'];
  }

  //console.log("defaultValue " + defaultValue)
  return (
    <ListInput
      {...props}
      onClick={props.onClick}
      inputStyle={inputStyle}
      //defaultValue={defaultValue}
      className={
        props.className +
        (showMonoSpace ? ' monospaceEdit' : '') +
        ' ' +
        md5Password(defaultValue)
      }
      type={props.type ? props.type : 'text'}
      label={(!props.quickForm && getInputLabel(props)) || ''}
      clearButton={!props.readonly && props.type !== 'number'}
    >
      {getInputLabelElement(props)}
    </ListInput>
  );
}

TextInput.propTypes = {
  activeMode: PropTypes.bool,
  inputId: PropTypes.string,
  title: PropTypes.string,
  style: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  absolutePlaceMode: PropTypes.bool,
  quickForm: PropTypes.bool,
  readonly: PropTypes.bool,
  value: PropTypes.any,
  placeholder: PropTypes.any,
  inputWidth: PropTypes.number,
  desktop: PropTypes.bool,
  monoSpace: PropTypes.bool,
  maxlength: PropTypes.number,
  data: PropTypes.object,
  scale: PropTypes.object,
  onClick: PropTypes.func
};

function TextArea(props) {
  const defaultValue = props['value'];
  delete props['value'];
  if (!props.placeholder) {
    delete props['placeholder'];
  }

  return (
    <ListInput
      type={'textarea'}
      {...props}
      onChange={event => {
        props.onChange && props.onChange(event);
        if (props.quickForm) {
          event.target.style.height = 'auto';
          event.target.style.height =
            Math.max(100, event.target.scrollHeight) + 'px';
        }
      }}
      defaultValue={defaultValue}
      className={
        props.className + (props.renderAsInput ? ' renderAsInput' : '')
      }
      label={(!props.quickForm && getInputLabel(props)) || ''}
      clearButton={!props.readonly}
    >
      {getInputLabelElement(props)}
    </ListInput>
  );
}

TextArea.propTypes = {
  inputId: PropTypes.string,
  title: PropTypes.string,
  style: PropTypes.string,
  className: PropTypes.string,
  absolutePlaceMode: PropTypes.bool,
  quickForm: PropTypes.bool,
  readonly: PropTypes.bool,
  value: PropTypes.any,
  placeholder: PropTypes.any,
  inputWidth: PropTypes.number,
  renderAsInput: PropTypes.bool,
  onChange: PropTypes.func
};

function readOnlyInputValue(id, value, absolutePlaceMode) {
  return (
    <span
      id={id}
      className={'readOnlyInputValue'}
      style={{
        whiteSpace: 'nowrap',
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        paddingLeft: absolutePlaceMode ? 0 : 10,
        textIndent: absolutePlaceMode ? 3 : 0
      }}
      slot={'input'}
    >
      {value}
    </span>
  );
}

function DateInput(props) {
  let calendar = null;
  const footer = getFooter(props);
  let className = props.className;

  const dateISO = checkDateAndGetISODate(props.value);
  const date = dateISO && new Date(dateISO);

  const todayDate = new Date().toDateString() + ' UTC';

  const dateInfo = date ? date : new Date();
  const headerWeekDay = dateInfo.toLocaleDateString(II18.locale(), {
    weekday: 'long'
  });

  const headerDay = dateInfo.toLocaleDateString(II18.locale(), {
    day: 'numeric'
  });

  const selectedDateValidationMessage =
    validateFormItem(
      props.data,
      props.value || todayDate,
      props.requestedDocuments
    )?.errMessage || '';

  // eslint-disable-next-line react/prop-types
  const CalendarContainer = ({ children }) => {
    const el = document.getElementById('calendarContainer');

    return <Portal container={el}>{children}</Portal>;
  };

  const showDoneButton = true;

  const isDateValidConditions = date => {
    return !isFormItemValidationHasErrors(
      validateFormItem(
        props.data,
        prepareDateToFormData(date),
        props.requestedDocuments
      )
    );
  };

  return (
    <ListInput
      {...props}
      label={(!props.quickForm && getInputLabel(props)) || ''}
      className={className}
      input={false}
      onClick={props.onClick}
    >
      {getInputLabelElement(props)}
      {props.readonly ? (
        readOnlyInputValue(
          props.inputId,
          displayDate(props.value),
          props.absolutePlaceMode
        )
      ) : (
        <DatePicker
          filterDate={isDateValidConditions}
          ref={c => {
            calendar = c;
          }}
          closeOnScroll={props.desktop}
          tabIndex={props.tabindex}
          locale={II18.locale()}
          slot={'input'}
          selected={date}
          onChange={e => props.onChange(e ? e.toDateString() + ' UTC' : '')}
          onYearChange={e =>
            isDateValidConditions(e) &&
            props.onChange(e.toDateString() + ' UTC')
          }
          onMonthChange={e =>
            isDateValidConditions(e) &&
            props.onChange(e.toDateString() + ' UTC')
          }
          dateFormat={II18.get('dateFormat')}
          id={props.inputId}
          showYearDropdown
          showMonthDropdown
          dropdownMode="select"
          shouldCloseOnSelect={!showDoneButton}
          portalId="commonPortal"
          popperContainer={!props.desktop && CalendarContainer}
          popperProps={props.desktop ? { strategy: 'fixed' } : undefined}
          popperModifiers={
            props.desktop
              ? [
                  {
                    name: 'flip',
                    options: {
                      rootBoundary: 'viewport',
                      padding: 8
                    }
                  },
                  {
                    name: 'preventOverflow',
                    options: {
                      rootBoundary: 'viewport',
                      boundary: 'viewport',
                      tether: false,
                      altAxis: true,
                      padding: 8
                    }
                  }
                ]
              : undefined
          }
          onFocus={e => {
            props.onClick(e);
            !props.desktop && e.target.blur();
          }}
          onKeyDown={e => {
            e.keyCode === 9 && calendar?.setOpen(false);
          }}
        >
          <div className={'rd-calendar-header'}>
            <span title={props.title}>{props.title}</span>
            <span>{headerWeekDay}</span>
            <span>{headerDay}</span>
            <button
              type="button"
              className="rd-calendar-close"
              aria-label={II18.get('title_close')}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                calendar?.setOpen(false);
              }}
            >
              <Icon material="close" />
            </button>
          </div>
          {showDoneButton && (
            <div className={'rd-calendar-footer'}>
              <div>
                <Button
                  onClick={e => calendar?.setSelected(new Date(), e)}
                  small
                  outline
                  color={'teal'}
                >
                  <II18>title_today</II18>
                </Button>
                <Button
                  style={{
                    minWidth: 60,
                    ...(selectedDateValidationMessage && {
                      backgroundColor: '#ccc'
                    })
                  }}
                  className={
                    'cal-done ' +
                    (selectedDateValidationMessage ? 'cal-not-ready' : '')
                  }
                  onClick={() => {
                    if (selectedDateValidationMessage) return;

                    calendar?.setOpen(false);
                    if (!date) {
                      props.onChange(todayDate);
                    }
                  }}
                  small
                  fill
                  color={'teal'}
                  tooltip={selectedDateValidationMessage || ''}
                >
                  {selectedDateValidationMessage ? '?' : 'Ok'}
                </Button>
              </div>
            </div>
          )}
        </DatePicker>
      )}
      {footer}
      {props.absolutePlaceMode
        ? getAbsolutePlaceModeClearButton(props)
        : !props.readonly && (
            <span
              onClick={() => props.onChange('')}
              className={'input-clear-button'}
              slot={'input'}
            ></span>
          )}
    </ListInput>
  );
  //);
}

DateInput.propTypes = {
  data: PropTypes.object,
  showPopupsInPortal: PropTypes.bool,
  tabindex: PropTypes.number,
  inputId: PropTypes.string,
  title: PropTypes.string,
  style: PropTypes.string,
  className: PropTypes.string,
  absolutePlaceMode: PropTypes.bool,
  quickForm: PropTypes.bool,
  readonly: PropTypes.bool,
  desktop: PropTypes.bool,
  ios: PropTypes.bool,
  value: PropTypes.any,
  key: PropTypes.any,
  placeholder: PropTypes.any,
  inputWidth: PropTypes.number,
  requestedDocuments: PropTypes.array,
  onChange: PropTypes.func,
  onClick: PropTypes.func
};

function Dropdown(props) {
  delete props.defaultValue;

  const value =
    props.value &&
    // eslint-disable-next-line no-constant-condition
    (Array.isArray(props.value[0])
      ? JSON.stringify(props.value[0])
      : props.value[0] || '');

  const sOptions = props.data.options.map(option => ({
    label: option.label,
    value: option.id
  }));
  const selectedOption = sOptions.find(option => option.value === value);

  return props.absolutePlaceMode ? (
    <ListInput
      {...props}
      label={getInputLabel(props) || ''}
      value={value}
      input={!props.readonly}
      type={!props.readonly ? 'select' : ''}
    >
      {props.readonly ? (
        readOnlyInputValue(
          props.inputId,
          selectedOption && selectedOption.label,
          props.absolutePlaceMode
        )
      ) : (
        <>
          <option disabled value="" style={{ display: 'none' }}></option>
          {props.data.options.map((option, index) => {
            const this_key = `preview_${index}`;
            return (
              <option
                data-tooltip={option.label}
                value={option.id}
                key={this_key}
              >
                {option.label}
              </option>
            );
          })}
        </>
      )}
      {getInputLabelElement(props)}
      {getAbsolutePlaceModeClearButton(props)}
    </ListInput>
  ) : (
    <ListInput
      {...props}
      label={(!props.quickForm && getInputLabel(props)) || ''}
      input={false}
      value={''}
    >
      {props.readonly ? (
        readOnlyInputValue(
          props.inputId,
          selectedOption && selectedOption.label,
          props.absolutePlaceMode
        )
      ) : (
        <Select
          menuPortalTarget={document.getElementById('commonPortal')}
          menuPosition="fixed"
          tabIndex={props.tabindex}
          className={'react-select'}
          placeholder={II18.get('title_dropdown_select')}
          onFocus={props.onFocus}
          onChange={option => props.onChange(option ? option.value : '')}
          id={props.inputId}
          slot={'input'}
          isClearable
          isSearchable={sOptions.length > 10}
          value={selectedOption}
          options={sOptions}
        />
      )}

      {getInputLabelElement(props)}
    </ListInput>
  );

  /*<ListItem
      className={props.className}
      header={props.optionalInfo}
      title={props.label}
      readOnly={props.readonly}
      key={props.key}
      disabled={props.readonly}
      value={value}
      inputid={props.inputId}
      outline={true}
      smartSelect
      smartSelectParams={{ openIn: 'sheet', closeOnSelect: true }}
    >
      <select {...smartSelectProps}>
        <option value="" disabled />
        {props.data.options.map(option => {
          const this_key = `preview_${option.id}`;
          return (
            <option value={option.id} key={this_key}>
              {option.label}
            </option>
          );
        })}
      </select>
      {footer}
    </ListItem>*/
}

Dropdown.propTypes = {
  showPopupsInPortal: PropTypes.bool,
  tabindex: PropTypes.number,
  inputId: PropTypes.string,
  title: PropTypes.string,
  style: PropTypes.string,
  className: PropTypes.string,
  absolutePlaceMode: PropTypes.bool,
  quickForm: PropTypes.bool,
  readonly: PropTypes.bool,
  desktop: PropTypes.bool,
  ios: PropTypes.bool,
  simpleSelect: PropTypes.bool,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  placeholder: PropTypes.any,
  inputWidth: PropTypes.number,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  data: PropTypes.object
};

function ListGroupWithFixedTooltip({
  tooltip,
  tooltipTrigger,
  tooltipError,
  ...props
}) {
  const { id } = props;

  useEffect(() => {
    if (!tooltip || !id) {
      return undefined;
    }

    const targetEl = document.getElementById(id);
    if (!targetEl || !f7) {
      return undefined;
    }

    const instance = createFixedF7Tooltip(f7, {
      targetEl,
      text: tooltip,
      trigger: tooltipTrigger,
      cssClass: tooltipError ? 'err' : undefined
    });

    return () => {
      if (instance && instance.destroy) {
        instance.destroy();
      }
    };
  }, [id, tooltip, tooltipTrigger, tooltipError]);

  return <ListGroup {...props} />;
}

ListGroupWithFixedTooltip.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltip: PropTypes.string,
  tooltipTrigger: PropTypes.string,
  tooltipError: PropTypes.bool
};

function Checkboxes(props) {
  const footer = getFooter(props);
  const checkboxGroupe =
    (props.data.options && props.data.options.length > 1) ||
    (props.label && props.data.options[0].label && !props.editBarMode);
  const hasValue = Boolean(props.value !== undefined && props.value[0]);
  const optionalLabel = (!checkboxGroupe && props.optionalInfo) || '';

  if (!checkboxGroupe && !props.label) {
    props.label = props.data.options[0].label;
  }

  const layoutSize = defineLayoutSize(props.optionsLayoutSize);

  const absoluteOptionTooltipProps = option => {
    if (!props.absolutePlaceMode) {
      return {};
    }
    const info = getAbsolutePlaceTooltipInfo(
      props.data,
      option,
      props.errorMessage
    );
    return {
      tooltip: info.text || undefined,
      tooltipError: info.isError
    };
  };

  return (
    <ListGroupWithFixedTooltip
      key={props.key}
      className={
        props.className +
        ' groupElement CheckBox ' +
        (props.errorMessage ? ' item-input-with-error-message' : '')
      }
      id={props.inputId}
      tooltip={props.absolutePlaceMode ? undefined : props.tooltip}
      tooltipError={props.absolutePlaceMode ? undefined : props.tooltipError}
    >
      {(props.label || props.errorMessage) && checkboxGroupe && (
        <ListItem
          header={props.editBarMode ? getInputLabel(props) : ''}
          info={props.info}
          key={'title'}
          className={'groupHeader'}
        >
          {getInputLabelElement(props)}
          {footer}
        </ListItem>
      )}

      {optionsBlockRenderAs(
        props.editBarMode,
        props.data.options.map(option => {
          const optionHtmlId = formOptionHtmlId(props.data, option);
          props.editBarMode && scrollTitle(optionHtmlId);

          const localProps = {
            name: props.name,
            value: option.id,
            key: option.id,
            onChange: props.onChange,
            style: props.absolutePlaceMode ? option.style : {},
            //defaultChecked: hasValue && props.value.indexOf(option.id) > -1
            checked: Boolean(hasValue && props.value.indexOf(option.id) > -1)
          };
          if (props.readonly) {
            localProps.disabled = true;
            localProps.readonly = true;
          }
          const optionLabel =
            props.absolutePlaceMode && checkboxGroupe
              ? props.label + ' / ' + option.label
              : option.label;

          return (
            <ListItem
              {...localProps}
              {...absoluteOptionTooltipProps(option)}
              key={localProps.key}
              id={optionHtmlId}
              className={
                'checkBox ' +
                (props.absolutePlaceMode ? ' inputElement' : '') +
                (localProps.readonly ? ' readonly' : '') +
                (!checkboxGroupe ? ' single' : '') +
                (hasValue ? ' item-input-with-value' : '') +
                (localProps.checked ? ' checked' : '') +
                ` ls-${layoutSize}` +
                props.animateClass
              }
              title={
                <label htmlFor={optionHtmlId}>
                  {((props.editBarMode ||
                    checkboxGroupe ||
                    props.absolutePlaceMode) &&
                    optionLabel) ||
                    ''}
                </label>
              }
              checkbox
              header={(!props.quickForm && optionalLabel) || ''}
              onClick={e => {
                props.onClick(e);
                setTimeout(function() {
                  props.onChange(e);
                }, 100);
              }}
            >
              {!checkboxGroupe && getInputLabelElement(props, true)}
              {!checkboxGroupe && footer}
              {checkboxGroupe && !props.label && props.optionalInfo && (
                <span slot={'title'}>
                  <Badge>optional</Badge>
                </span>
              )}
            </ListItem>
          );
        })
      )}
    </ListGroupWithFixedTooltip>
  );
}

Checkboxes.propTypes = {
  optionsLayoutSize: PropTypes.number,
  inputId: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  info: PropTypes.string,
  key: PropTypes.string,
  errorMessage: PropTypes.string,
  optionalInfo: PropTypes.string,
  title: PropTypes.string,
  tooltip: PropTypes.string,
  tooltipError: PropTypes.bool,
  style: PropTypes.string,
  className: PropTypes.string,
  animateClass: PropTypes.string,
  absolutePlaceMode: PropTypes.bool,
  quickForm: PropTypes.bool,
  readonly: PropTypes.bool,
  desktop: PropTypes.bool,
  ios: PropTypes.bool,
  simpleSelect: PropTypes.bool,
  editBarMode: PropTypes.bool,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  placeholder: PropTypes.any,
  inputWidth: PropTypes.number,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  data: PropTypes.object
};

function optionsBlockRenderAs(scrollable, items) {
  let height = items.length > 6 ? 300 : 'auto';
  return !scrollable ? (
    items
  ) : (
    <li>
      <ul style={{ padding: 0, height: height, overflowY: 'scroll' }}>
        {items}
      </ul>
    </li>
  );
}

const scrollTimers = [];

function scrollTitle(inputId) {
  let step = 1;
  if (!scrollTimers[inputId]) {
    scrollTimers[inputId] = true;
    const myInterval = setInterval(function() {
      const element = document.querySelector(
        '[id="' + inputId + '"].checked .item-title'
      );
      if (element) {
        element.scrollLeft += step;
        if (
          element.clientWidth + element.scrollLeft > element.scrollWidth - 1 ||
          element.scrollLeft <= 0
        ) {
          step = -step;
        }
      } else {
        clearInterval(myInterval);
        delete scrollTimers[inputId];
      }
    }, 50);
  }
}

function RadioButtons(props) {
  const footer = getFooter(props);
  let value = (props.value && props.value[0]?.toString()) || '';

  const layoutSize = defineLayoutSize(props.optionsLayoutSize);

  const absoluteOptionTooltipProps = option => {
    if (!props.absolutePlaceMode) {
      return {};
    }
    const info = getAbsolutePlaceTooltipInfo(
      props.data,
      option,
      props.errorMessage
    );
    return {
      tooltip: info.text || undefined,
      tooltipError: info.isError
    };
  };

  return (
    <ListGroupWithFixedTooltip
      key={props.key}
      className={
        props.className +
        ' groupElement RadioButton ' +
        (props.errorMessage ? ' item-input-with-error-message' : '')
      }
      id={props.inputId}
      tooltip={props.absolutePlaceMode ? undefined : props.tooltip}
      tooltipError={props.absolutePlaceMode ? undefined : props.tooltipError}
    >
      {(props.label || props.errorMessage) && (
        <ListItem
          header={props.editBarMode ? getInputLabel(props) : undefined}
          key={'title'}
          className={'groupHeader'}
        >
          {getInputLabelElement(props)}
          {footer}
        </ListItem>
      )}

      {optionsBlockRenderAs(
        props.editBarMode,
        props.data.options.map(option => {
          const optionHtmlId = formOptionHtmlId(props.data, option);
          const optionInputHtmlId = formOptionInputHtmlId(props.data, option);
          props.editBarMode && scrollTitle(optionHtmlId);

          const optionProps = {};
          optionProps.name = props.name;
          optionProps.value = option.id.toString();
          optionProps.key = option.id;
          optionProps.checked = optionProps.value === value;
          //optionProps.onChange = props.onChange;
          optionProps.style = props.absolutePlaceMode ? option.style : {};

          if (props.readonly) {
            optionProps.disabled = true;
            optionProps.readonly = true;
          }

          const optionLabel = (
            <label htmlFor={optionInputHtmlId}>
              {props.absolutePlaceMode
                ? props.label + ' / ' + option.label
                : option.label}
            </label>
          );

          return (
            <ListItem
              id={optionHtmlId}
              key={optionProps.key}
              className={
                'radioButton ' +
                (props.absolutePlaceMode ? ' inputElement' : '') +
                (optionProps.readonly ? ' readonly' : '') +
                (value ? ' item-input-with-value' : '') +
                (optionProps.checked ? ' checked' : '') +
                ` ls-${layoutSize}` +
                props.animateClass
              }
              {...optionProps}
              {...absoluteOptionTooltipProps(option)}
              title={optionLabel}
              onClick={e => {
                props.onChange(optionProps.value);
                setTimeout(() => props.onClick(e), 50);
              }}
            >
              <Radio
                slot="media"
                name={props.inputId}
                id={props.inputId}
                value={optionProps.value}
                checked={optionProps.checked}
                inputId={optionInputHtmlId}
                onChange={() => props.onChange(optionProps.value)}
              />
            </ListItem>
          );
        })
      )}
    </ListGroupWithFixedTooltip>
  );
}

RadioButtons.propTypes = {
  optionsLayoutSize: PropTypes.number,
  inputId: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  info: PropTypes.string,
  key: PropTypes.string,
  errorMessage: PropTypes.string,
  title: PropTypes.string,
  tooltip: PropTypes.string,
  tooltipError: PropTypes.bool,
  style: PropTypes.string,
  className: PropTypes.string,
  animateClass: PropTypes.string,
  absolutePlaceMode: PropTypes.bool,
  quickForm: PropTypes.bool,
  readonly: PropTypes.bool,
  desktop: PropTypes.bool,
  ios: PropTypes.bool,
  simpleSelect: PropTypes.bool,
  editBarMode: PropTypes.bool,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  placeholder: PropTypes.any,
  inputWidth: PropTypes.number,
  tabindex: PropTypes.number,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  data: PropTypes.object
};

function Signature(props) {
  const displaySignatureUrl = props.value || props.defaultValue;

  return props.absolutePlaceMode && displaySignatureUrl ? (
    <ListItem
      {...props}
      title={props.title || II18.get('forms_sign')}
      readOnly={props.readonly}
      className={
        props.className +
        ' signatureItem withImage ' +
        (props.isQualified ? 'st-QUALIFIED' : '')
      }
    >
      <img
        alt={II18.get('forms_sign') + ' ' + props.title}
        src={displaySignatureUrl}
        style={{ maxWidth: '100%', maxHeight: '100%' }}
      />
    </ListItem>
  ) : (
    <Fragment>
      <ListItem
        {...props}
        title={props.title || II18.get('forms_sign')}
        readOnly={props.readonly}
        className={
          props.className +
          ' signatureItem' +
          (props.errorMessage ? ' item-input-with-error-message' : '') +
          (props.isQualified ? ' st-QUALIFIED' : '')
        }
        key={'signatureTitle'}
      >
        <div
          id={props.inputId}
          tabIndex={props.tabindex}
          className={'signatureDiv' + (props.readonly ? ' readonly' : '')}
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0
          }}
          onKeyDown={e => {
            if (e.keyCode === 13) {
              e.preventDefault();
              props.onClick();
            }
          }}
        />
        {props.errorMessage && (
          <label slot={'footer'} style={{ color: 'red' }}>
            {props.errorMessage}
          </label>
        )}
        {props.absolutePlaceMode ? (
          <Icon icon={'fas fa-signature'} slot="after" />
        ) : (
          props.editBarMode &&
          !props.readonly && (
            <Button raised fill round slot="after">
              <Icon icon={'fas fa-signature'} style={{ fontSize: 16 }} />
            </Button>
          )
        )}
        {props.optionalInfo && (
          <span slot={'title'}>
            <Badge>optional</Badge>
          </span>
        )}
      </ListItem>

      {!props.editBarMode && !props.absolutePlaceMode && (
        <ListItem
          onClick={props.onClick}
          className={'quickFormSign quickFormSign_' + props.inputId}
          tooltip={props.tooltip}
        >
          <div
            tabIndex={props.tabindex}
            className={'sign_box' + (displaySignatureUrl ? ' withSign' : '')}
            onKeyDown={e => {
              if (e.keyCode === 13) {
                e.preventDefault();
                props.onClick();
              }
            }}
          >
            {displaySignatureUrl && (
              <img
                id={props.inputId}
                alt={'Signature'}
                src={displaySignatureUrl}
                style={{ maxWidth: 200 }}
              />
            )}
            {!displaySignatureUrl && (
              <>
                <span className={'sign_x'}>x</span>
                <span className={'sign_line'} />
              </>
            )}
          </div>
          {!displaySignatureUrl && (
            <Icon icon={'fas fa-signature'} slot="after" />
          )}
          <span id={'signatureEnd_' + props.inputId} />
        </ListItem>
      )}

      {/*displaySignatureUrl && !props.editBarMode && (
        <ListItem
          className={'signatureDiv' + (props.readonly ? ' readonly' : '')}
          onClick={() => !props.readonly && props.onClick()}
        >
          <img
            id={props.inputId}
            alt={''}
            src={displaySignatureUrl}
            style={{ maxWidth: 200 }}
          />
          <span id={'signatureEnd_' + props.inputId} />
        </ListItem>
      )*/}
    </Fragment>
  );
}

Signature.propTypes = {
  inputId: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  info: PropTypes.string,
  key: PropTypes.string,
  errorMessage: PropTypes.string,
  optionalInfo: PropTypes.string,
  title: PropTypes.string,
  tooltip: PropTypes.string,
  tooltipError: PropTypes.bool,
  style: PropTypes.string,
  className: PropTypes.string,
  absolutePlaceMode: PropTypes.bool,
  quickForm: PropTypes.bool,
  readonly: PropTypes.bool,
  desktop: PropTypes.bool,
  ios: PropTypes.bool,
  simpleSelect: PropTypes.bool,
  editBarMode: PropTypes.bool,
  isQualified: PropTypes.bool,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  placeholder: PropTypes.any,
  inputWidth: PropTypes.number,
  tabindex: PropTypes.number,
  onClick: PropTypes.func,
  data: PropTypes.object
};

FormElements.Paragraph = Paragraph;
FormElements.Label = Label;
FormElements.LineBreak = LineBreak;
FormElements.TextInput = TextInput;
FormElements.NumberInput = NumberInput;
FormElements.TextArea = TextArea;
FormElements.Dropdown = Dropdown;
FormElements.Signature = Signature;
FormElements.Checkboxes = Checkboxes;
FormElements.DatePicker = DateInput;
FormElements.TimePicker = TimeInput;
FormElements.RadioButtons = RadioButtons;
FormElements.HyperLink = HyperLink;
FormElements.Rectangle = Rectangle;
FormElements.Image = Image;
FormElements.AcceptButton = AcceptButton;
FormElements.MobileSplitNumber = MobileSplitNumber;

export default FormElements;
